import axios from "../utils/axios.wrapper";

export const getContracts = async () => {
  const { data } = await axios.get("/Contract");
  // Backend returns { items: [...], totalCount: N } or { Items: [...], TotalCount: N }
  return {
    items: data.items || data.Items || data,
    totalCount: data.totalCount || data.TotalCount || (Array.isArray(data) ? data.length : 0)
  };
};

export const getActiveContracts = async () => {
  const { data } = await axios.get("/Contract/active");
  // Backend returns { items: [...], totalCount: N } or { Items: [...], TotalCount: N }
  return {
    items: data.items || data.Items || data,
    totalCount: data.totalCount || data.TotalCount || (Array.isArray(data) ? data.length : 0)
  };
};

export const getInactiveContracts = async () => {
  const { data } = await axios.get("/Contract/inactive");
  // Backend returns { items: [...], totalCount: N } or { Items: [...], TotalCount: N }
  return {
    items: data.items || data.Items || data,
    totalCount: data.totalCount || data.TotalCount || (Array.isArray(data) ? data.length : 0)
  };
};

export const getContractById = async (id) => {
  const { data } = await axios.get(`/Contract/${id}`);
  return data;
};

export const getContractByNumber = async (contractNumber) => {
  const { data } = await axios.get(`/Contract/number/${contractNumber}`);
  return data;
};

export const createContract = async (contract) => {
  const { data } = await axios.post("/Contract/create", contract);
  return data;
};

export const updateContract = async (id, contract) => {
  const { data } = await axios.put(`/Contract/${id}`, contract);
  return data;
};

export const deleteContract = async (id) => {
  const { data } = await axios.delete(`/Contract/${id}`);
  return data;
};

export const hardDeleteContract = async (id) => {
  const { data } = await axios.delete(`/Contract/hard/${id}`);
  return data;
};

export const contractService = {
  getContracts,
  getActiveContracts,
  getInactiveContracts,
  getContractById,
  getContractByNumber,
  createContract,
  updateContract,
  deleteContract,
  hardDeleteContract,
};